import React from "react";
import { Button } from "react-bootstrap";
import autoBind from "react-autobind";
import _ from "lodash";

import PlayerItemValueReadOnly from "./PlayerItemValueReadOnly";
import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import { getSelectedStyles, getPrefixedStyles } from "../../utils/utils";
import DoneButton from "./DoneButton";

class PlayerYesNo extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	onClick(event, value) {
		if (this.props.disabled) {
			return;
		}

		let item = this.props.item;
		//for buttons we submit immediately
		if ((item.hasOwnProperty("yesNoAdvanceOnSelect") && item.yesNoAdvanceOnSelect === true) ||
			(item.hasOwnProperty("yesNoLinkOnSelect") && item.yesNoLinkOnSelect === true)) {						
			this.handleSubmitCallback(value);
		} else {
			this.handleOnChangeCallback(value);
		}
	}

	handleSubmitCallback(value, forceNav = false) {
		if (this.props.onSubmit && _.isFunction(this.props.onSubmit)) {
			console.log("SUBMIT", value, forceNav);
			const { listIndex, sectionIndex, itemIndex, identityId, disabled,item } = this.props;
			this.props.onSubmit({ value, listIndex, sectionIndex, itemIndex, identityId, disabled, forceNav, item });
		}
	}

	handleOnChangeCallback(value) {
		if (this.props.onChange) {
			const { listIndex, sectionIndex, itemIndex, disabled } = this.props;
			this.props.onChange({ value, listIndex, sectionIndex, itemIndex, disabled });
		}
	}

	onClickDone() {
		this.handleSubmitCallback(this.props.item.value, true);
	}

	renderReadOnly() {
		return (
			<PlayerItemValueReadOnly item={this.props.item} />
		);
	}

	renderEditable() {

		const { item, getImage, getVideo, getPdf, listIndex, sectionIndex, itemIndex, disabled } = this.props;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const yesNoItemTheme = _.get(theme, "item.yesNo");

		let yesSelected = false;
		let noSelected = false;
		let naSelected = false;
		const hasValue = !_.isEmpty(item.value);
		if (hasValue) {
			switch (item.value) {
				case "yes": {
					yesSelected = true;
					break;
				}
				case "no": {
					noSelected = true;
					break;
				}
				case "n/a": {
					naSelected = true;
					break;
				}
				default: { console.log("No default"); }
			}
		}

		let yesStyles = _.assign(yesNoItemTheme.yesButton,getSelectedStyles(yesNoItemTheme.yesButton, yesSelected));
		if (!yesSelected && hasValue) {
			yesStyles = _.assign({}, yesStyles, getPrefixedStyles(yesNoItemTheme.yesButton, "disabled"));
		} 
		let noStyles = _.assign(yesNoItemTheme.noButton,getSelectedStyles(yesNoItemTheme.noButton, item.value === "no"));
		if (!noSelected && hasValue) {
			noStyles = _.assign({}, noStyles, getPrefixedStyles(yesNoItemTheme.noButton, "disabled"));
		} 
		let naStyles = _.assign(yesNoItemTheme.naButton,getSelectedStyles(yesNoItemTheme.naButton, item.value === "n/a"));
		if (!naSelected && hasValue) {
			naStyles = _.assign({}, naStyles, getPrefixedStyles(yesNoItemTheme.naButton, "disabled"));
		} 

		let doneButton;
		
		if (!disabled && item.selected && item.value !== null && item.value !== "" && ((item.hasOwnProperty("yesNoAdvanceOnSelect") && !item.yesNoAdvanceOnSelect) || item.yesNoLinkOnSelect)) {
			doneButton = <DoneButton onSubmit={this.onClickDone} />;
		}

		const buttonContainerStyle = { flex: 1, alignItems: "center", justifyContent: "center", cursor: "pointer", padding: "20px 20px 15px 20px" };
		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
				<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
				<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
				{getImage()}
				{getVideo()}
				{getPdf()}
				<div style={{ display: "flex", flexDirection: "row" }}>
					<div style={buttonContainerStyle} onClick={(e) => this.onClick(e, "yes")}>
						<div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "center"}}>
							<Button disabled={disabled} style={_.assign(yesStyles,{width: "100%"})}>Yes</Button>
						</div>
					</div>
					<div style={buttonContainerStyle}onClick={(e) => this.onClick(e, "no")}>
						<div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "center"}}>
							<Button disabled={disabled} style={_.assign(noStyles,{width: "100%"})}>No</Button>
						</div>	
					</div>
					{this.props.item.hasOwnProperty("yesNoShowNa") && this.props.item.yesNoShowNa && <div style={buttonContainerStyle} onClick={(e) => this.onClick(e, "n/a")}>
						<div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "center"}}>
							<Button disabled={disabled} style={_.assign(naStyles,{width: "100%"})}>N/A</Button>
						</div>
					</div>
					}			
				</div>
				{doneButton}
			</div>
		</div>;
		return component;
	}
}

export default withPlayerItemHoc(PlayerYesNo);